/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { Tag, TagFromJSON, TagFromJSONTyped, TagToJSON } from "./Tag";

/**
 *
 * @export
 * @interface TagListControllerResponse
 */
export interface TagListControllerResponse {
  /**
   *
   * @type {Array<Tag>}
   * @memberof TagListControllerResponse
   */
  data?: Array<Tag> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof TagListControllerResponse
   */
  error?: ErrorResponse;
}

export function TagListControllerResponseFromJSON(json: any): TagListControllerResponse {
  return TagListControllerResponseFromJSONTyped(json, false);
}

export function TagListControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TagListControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
      ? null
      : (json["data"] as Array<any>).map(TagFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function TagListControllerResponseToJSON(value?: TagListControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: value.data === undefined ? undefined : value.data === null ? null : (value.data as Array<any>).map(TagToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
